import { render, staticRenderFns } from "./WorkerVehicleSingleWork.vue?vue&type=template&id=6abf8af5&scoped=true"
import script from "./WorkerVehicleSingleWork.vue?vue&type=script&lang=js"
export * from "./WorkerVehicleSingleWork.vue?vue&type=script&lang=js"
import style0 from "./WorkerVehicleSingleWork.vue?vue&type=style&index=0&id=6abf8af5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abf8af5",
  null
  
)

export default component.exports